// src/App.tsx
import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import { UnifiedUserProvider } from "./context/UserContext";
import AppRoutes from "./routes/routes";
import { PremiumStatusProvider } from "./context/PremiumStatusContext";

function App() {
  useEffect(() => {
    // Create a new style element
    const style = document.createElement("style");
    style.innerHTML = `
      /* Override WordPress CSS */
      .page-id-12067 .nav-menu li a span {
        color: inherit !important;
      }
    `;

    // Append the style element to the document head
    document.head.appendChild(style);

    // Cleanup function to remove the style when the component unmounts
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <UnifiedUserProvider>
          <PremiumStatusProvider>
            <AppRoutes />
          </PremiumStatusProvider>
        </UnifiedUserProvider>
      </div>
    </Router>
  );
}

export default App;
